import { motion } from "framer-motion";

const testimonials = [
  {
    content: "This platform has completely transformed how we handle our AI workflows. The interface is intuitive and the results are impressive.",
    author: "Sarah Johnson",
    role: "CTO at TechCorp",
    image: "https://randomuser.me/api/portraits/women/1.jpg"
  },
  {
    content: "The AI capabilities are state-of-the-art, and the customer support team is always there when we need them. Highly recommended!",
    author: "Michael Chen",
    role: "Product Manager at InnovateLabs",
    image: "https://randomuser.me/api/portraits/men/1.jpg"
  },
  {
    content: "We've seen a 300% increase in productivity since implementing this solution. It's been a game-changer for our team.",
    author: "Emily Rodriguez",
    role: "Director of AI at FutureTech",
    image: "https://randomuser.me/api/portraits/women/2.jpg"
  }
];

const Testimonials = () => {
  return (
    <section className="py-20 overflow-hidden" id="testimonials">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
          >
            What our clients say
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-gray-400"
          >
            Don't just take our word for it - hear from some of our satisfied clients.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="p-8 rounded-2xl bg-[#ffffff]/40 dark:bg-[#151C31] border border-[#1E2A4A] hover:border-gray-700 transition-colors"
            >
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h4 className="text-lg font-semibold">{testimonial.author}</h4>
                  <p className="text-sm text-gray-400">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-gray-400">{testimonial.content}</p>
              <div className="mt-6 flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
